import { Component, OnInit } from '@angular/core';
import { Address } from '../core/models/address';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { AppState } from '../interfaces';
import * as orderSelector from '../core/store/order/order.selectors';
import * as uiSelector from '../core/store/ui/ui.selectors';
import {
  SetPaymentType,
  SetActeType,
  ToggleSendByMail,
  SetRemarks,
  SetNN,
  IOrder,
  ToggleOnlinePayment
} from '../core/store/order';
import { Product } from '../core/models/product';
import { SetIAgree, SetStep4Valid, IUI } from '../core/store/ui';
import { DataService } from '../core/services/data.service';
import { Region } from '../core/models/region';
import { UserType, Contact, Owner, User, UserDB } from '../core/models/user';
import { Document } from '../core/models/document';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar, MatDialog } from '@angular/material';
import { AuthService } from '../core/services/auth.service';
import { CongratsDialogComponent } from '../dialogs/congrats-dialog/congrats-dialog.component';
import { GoogleAnalyticsService } from '../core/services/google-analytics.service';
import { DefaultDialogComponent } from '../dialogs/default-dialog/default-dialog.component';

import { orderMeansType } from '../core/data';
import { showFinalOptions, step4ShowByMail } from '../core/data/theme-config';

@Component({
  selector: 'app-step4',
  templateUrl: './step4.component.html',
  styleUrls: ['./step4.component.scss']
})
export class Step4Component implements OnInit {
  API_CREATE_ORDER = 'https://systems.certinergie.be/api/NewOrdering/create';
  // paymentType: string;
  acteType: string;
  sendByMail: boolean;
  onlinePayment: boolean;
  remarks: string;
  priceWithoutReduction: number;
  reduction: number;
  paymentType: string;
  submitNotValid = false;

  step1IsValid: boolean;
  step2IsValid: boolean;
  step3IsValid: boolean;
  step4IsValid: boolean;

  products: Product[];
  hasPeb: boolean;
  hasElec: boolean;
  isUrgent: boolean;

  order: IOrder;
  ui: IUI;

  userTypes = UserType;

  $paymentType: Observable<string>;
  $acteType: Observable<string>;
  $sendByMail: Observable<boolean>;
  $remarks: Observable<string>;
  $products: Observable<Product[]>;
  $IAgree: Observable<boolean>;
  $selectedRegion: Observable<Region>;
  $estateName: Observable<string>;
  $estateType: Observable<number>;
  $visitAddress: Observable<Address>;
  $dateButoir: Observable<any>;
  $goGetKeys: Observable<boolean>;
  $userType: Observable<UserType>;
  $contact: Observable<Contact>;
  $owner: Observable<Owner>;
  $user: Observable<User>;
  $document: Observable<Document>;
  $nn: Observable<string>;
  $language: Observable<string>;
  $urgence: Observable<boolean>;
  $onlinePayment: Observable<boolean>;
  $hasPeb: Observable<boolean>;
  $hasElec: Observable<boolean>;
  $isUrgent: Observable<boolean>;

  showFinalOptions = showFinalOptions;
  step4ShowByMail = step4ShowByMail;

  constructor(
    private store: Store<AppState>,
    private dataService: DataService,
    private http: HttpClient,
    private snackBar: MatSnackBar,
    private authService: AuthService,
    private dialog: MatDialog,
    private googleAnalyticsService: GoogleAnalyticsService
  ) {
    this.sendByMail = true;
  }

  ngOnInit() {
    this.$paymentType = this.store.select(orderSelector.getPaymentType);
    this.$acteType = this.store.select(orderSelector.getActeType);
    this.$sendByMail = this.store.select(orderSelector.getSendByMail);
    this.$remarks = this.store.select(orderSelector.getRemarks);
    this.$products = this.store.select(orderSelector.getProducts);
    this.$IAgree = this.store.select(uiSelector.getIAgree);
    this.$selectedRegion = this.store.select(orderSelector.getRegionInfo);
    this.$estateName = this.store.select(orderSelector.getEstateName);
    this.$visitAddress = this.store.select(orderSelector.getAddress);
    this.$dateButoir = this.store.select(orderSelector.getDateButoir);
    this.$goGetKeys = this.store.select(orderSelector.getGoGeyKeys);
    this.$contact = this.store.select(orderSelector.getContact);
    this.$userType = this.store.select(orderSelector.getUserType);
    this.$owner = this.store.select(orderSelector.getOwner);
    this.$user = this.store.select(orderSelector.getUser);
    this.$document = this.store.select(orderSelector.getDocument);
    this.$nn = this.store.select(orderSelector.getNN);
    this.$language = this.store.select(uiSelector.getLanguage);
    this.$estateType = this.store.select(orderSelector.getEstateID);
    this.$urgence = this.store.select(orderSelector.getUrgence);
    this.$onlinePayment = this.store.select(orderSelector.getOnlinePayment);
    this.store.select(orderSelector.getReduction).subscribe(reduc => (this.reduction = reduc));
    this.$hasPeb = this.store.select(orderSelector.hasPeb);
    this.$hasElec = this.store.select(orderSelector.hasElec);
    this.$isUrgent = this.store.select(orderSelector.getUrgence);

    this.$products.subscribe(p => (this.products = p));
    this.$hasPeb.subscribe(h => (this.hasPeb = h));
    this.$hasElec.subscribe(h => (this.hasElec = h));
    this.$isUrgent.subscribe(u => (this.isUrgent = u));

    this.$paymentType.subscribe(pt => (this.paymentType = pt));
    this.store.select(orderSelector.getPriceWithoutReduction).subscribe(price => {
      this.priceWithoutReduction = price;
    });
    this.store.select(orderSelector.getOrder).subscribe(o => (this.order = o));
    this.store.select(uiSelector.getUI).subscribe(u => (this.ui = u));
    this.store.select(uiSelector.getStep1IsValid).subscribe(s => (this.step1IsValid = s));
    this.store.select(uiSelector.getStep2IsValid).subscribe(s => (this.step2IsValid = s));
    this.store.select(uiSelector.getStep3IsValid).subscribe(s => (this.step3IsValid = s));
    this.store.select(uiSelector.getStep4IsValid).subscribe(s => (this.step4IsValid = s));

    this.store.select(orderSelector.getRemarks).subscribe(string => (this.remarks = string));

    this.$onlinePayment.subscribe(online => {
      this.onlinePayment = online;
      if (online) {
        this.store.dispatch(new SetPaymentType('online'));
      }
    });

    this.$IAgree.subscribe(ia => {
      this.store.dispatch(new SetStep4Valid(ia));
    });
  }

  selectPayment(type: string) {
    if (type === 'online') {
      this.store.dispatch(new ToggleOnlinePayment(true));
    } else {
      this.store.dispatch(new ToggleOnlinePayment(false));
      this.store.dispatch(new SetPaymentType(type));
    }
  }

  selectActe(type: string) {
    this.store.dispatch(new SetActeType(type));
  }

  toggleSendByMail() {
    this.store.dispatch(new ToggleSendByMail(true));
  }

  SetRemarks(rem: string) {
    this.store.dispatch(new SetRemarks(rem));
  }

  toggleIAgree() {
    this.store.dispatch(new SetIAgree(true));
  }

  setNN(nn: string) {
    this.store.dispatch(new SetNN(nn));
  }

  checkIfProducts(order): boolean {
    const hasProdducts = order.OrderProducts.length > 0;
    const hasPrice = order.Invoice.TotalPrice > 0;
    if (hasProdducts && hasPrice) {
      return true;
    }
    return false;
  }

  finalizeOrder() {
    this.googleAnalyticsService.emitEvent('bouton', 'clic', 'étape 4 valider');

    const orderIsValid = this.step1IsValid && this.step3IsValid && this.step4IsValid;
    // <-- NABIL reformat/map and clean order object before posting to Certinergie/NewOrder/api
    if (orderIsValid) {
      this.submitNotValid = false;
      const order = this.mapdOrderForDb();
      const hasProducts = this.checkIfProducts(order);

      if (!hasProducts) {
        this.dialog.open(DefaultDialogComponent, {
          panelClass: ['default-dialog'],
          data: {
            dialog: this.dialog,
            style: 'error'
          },
          disableClose: true,
          autoFocus: false
        });
      }

      // NABIL Add link to Stripe payment with OrderID from success response
      this.http.post<any>(this.API_CREATE_ORDER, order).subscribe(
        val => {
          console.log(`🚀`);
          // this.snackBar.open('🚀 Commande créée avec succès 🚀');
          const userDB: UserDB = val.Data;
          const orderID: string = val.Data.OrderID;
          // const user = this.authService.mapUserdbToUser(userDB);
          // this.store.dispatch(new SetUserInfo(user));

          const displayAgenda =
            !this.isUrgent &&
            (((this.hasPeb || this.hasElec) && this.products.length === 1) ||
              (this.hasPeb && this.hasElec && this.products.length === 2));

          const dialogRef = this.dialog.open(CongratsDialogComponent, {
            panelClass: ['congrats-dialog', 'no-padding-dialog'],
            data: {
              onlinePayment: this.onlinePayment,
              orderid: orderID,
              dialog: this.dialog,
              displayAgenda: displayAgenda
            },
            disableClose: true,
            autoFocus: false
          });

          this.authService.orderSuccessLogin(userDB.UserID);
        },
        error => {
          console.log('POST call in error', error);
          this.snackBar.open('Une erreur a eu lieu lors de la création de votre commande 😰');
        },
        () => {
          console.log('The POST observable is now completed.');
        }
      );
    } else {
      this.submitNotValid = true;
      console.log('😰 order not valid');
    }
  }

  mapdOrderForDb() {
    const o = this.order;
    const u = this.ui;

    const orderProducts = o.products
      .filter(op => op.id !== 1001)
      .filter(op => op.id !== -2)
      .map(op => {
        return {
          ProductTypeId: op.id === 11111 ? 1 : op.id,
          ProductName: op.name,
          Description: o.estateType,
          TotalTVAC: op.price,
          Reduction: op.reduction,
          ContactName: o.goGetKeys ? '/' : o.contact.lastname,
          ContactSurname: o.goGetKeys ? '/' : o.contact.firstname,
          // tslint:disable-next-line:quotemark
          ContactPhone: o.goGetKeys ? "Clé à l'agence" : o.contact.phone
        };
      });

    // no reductions if urgence
    let orderReductions = o.urgence
      ? null
      : o.reductions
          .filter(r => r.id !== 1001)
          .map(op => {
            return {
              TypeId: op.id,
              Description: op.type,
              Reduction: op.price
            };
          });

    let reducWithoutOR = 0;
    o.reductions.filter(r => r.id !== 1001).forEach(r => (reducWithoutOR = reducWithoutOR + +r.price));

    let immoRed = 0;
    o.reductions
      .filter(
        r =>
          r.id < 1000 &&
          r.id !== 1 &&
          r.id !== 11 &&
          r.id !== 4 &&
          r.id !== 8 &&
          r.id !== 6 &&
          r.id !== 9 &&
          r.id !== 15 &&
          r.id !== 16 &&
          r.id !== 51 &&
          r.id !== 55 &&
          r.id !== 56 &&
          r.id !== 57 &&
          r.id !== 17
      )
      .forEach(r => (immoRed = immoRed + +r.price));

    o.reduction = o.urgence ? 0 : reducWithoutOR;

    o.reduction = o.reduction - o.commission;

    // defaults non needed values
    if (o.paymentType !== 'acte') {
      o.nn = null;
      o.acteType = 'ILLPAY';
    }
    if (o.urgence) {
      orderReductions = null;
      o.promoCode = null;
    }

    let remarque = o.dateButoir
      ? 'Date Butoir : ' +
        (function(d) {
          const date = new Date(d);
          return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
        })(o.dateButoir)
      : '';

    /* if (data.partielNumber !== '') {
    remarque =
      remarque + "\n" + "Numéro du partiel existant : " + data.partielNumber;
  } */

    if (o.pebNb && o.pebNb !== '') {
      remarque = remarque + '\n' + 'Numéro du PEB partiel existant : ' + o.pebNb;
    }

    if (o.nn != null) {
      // tslint:disable-next-line:quotemark
      remarque = remarque + '\n' + "Numéro national en cas d'acte : " + o.nn;
    }

    if (o.promoCode && o.promoCode !== '') {
      remarque = remarque + '\n' + 'codepromo:' + o.promoCode;
    }

    if (remarque !== '') {
      remarque = remarque + '\n' + '-----------------';
    }

    remarque = remarque + '\n' + o.remarks;

    const lan = u.language === 'nl' ? 1 : u.language === 'en' ? 2 : u.language === 'de' ? 3 : 0;
    let docName = '';

    if (o.document.firstName && o.document.lastName) {
      docName = o.document.firstName + ' ' + o.document.lastName;
    } else if (o.document.firstName) {
      docName = o.document.firstName;
    } else if (o.document.lastName) {
      docName = o.document.lastName;
    }

    const dbOrder = {
      Order: {
        EstateType: o.estateType,
        RegionLocation: o.regionType,
        OrderCommission: o.commission,
        NeedBDC: o.acteType === 'BDC' || o.user.userType === this.userTypes.Agence,
        SentByMail: o.sendByMail,
        Language: lan,
        ImmoDiscount: immoRed,
        PromoCode: o.promoCode,
        GoGetKeys: o.goGetKeys,
        PromoCodeID: o.promoCodeID,
        PackID: o.packID,
        OrderMeansType: orderMeansType
      },
      Invoice: {
        IsDeedPayment: o.paymentType === 'acte',
        TotalPrice: o.price - o.reduction,
        NotaryActeChoice: o.acteType === 'BDC' ? 1 : o.acteType === 'NN' ? 2 : 0
      },
      InvoiceConsumerType: o.invoiceTo === 'toProprio' ? 1 : 0,
      AddressBien: {
        Name: null,
        Company: null,
        Street: o.address.street,
        Number: o.address.number,
        PostalCode: isNaN(parseInt(o.address.zip, 10)) ? null : parseInt(o.address.zip, 10),
        City: o.address.city,
        Country: o.address.country ? o.address.country : 'Belgique'
      },
      AddressEnvois: {
        Name: docName,
        Company: o.document.companyName ? o.document.companyName : '',
        Street: o.document.address.street ? o.document.address.street : '',
        Number: o.document.address.number ? o.document.address.number : '',
        Latitude: o.document.address.lat,
        Longitude: o.document.address.lng,
        VatNumber:
          o.document.tva && o.document.tva !== ''
            ? o.document.tva
            : o.invoiceTo === 'toProprio' || o.invoiceTo === 'toProprioAndPro'
            ? ''
            : o.user.tva,
        PostalCode: isNaN(parseInt(o.document.address.zip, 10)) ? null : parseInt(o.document.address.zip, 10),
        City: o.document.address.city,
        Country: o.document.address.country
      },
      OrderProducts: orderProducts,
      OrderReductions: orderReductions,
      OrderConsumer: {
        ConsumerType: o.user.userType,
        UserID: o.user.userid,
        User: {
          Email: o.user.email,
          FirstName: o.user.firstname,
          Name: o.user.lastname,
          Language: u.language === 'nl' ? 'nl-BE' : u.language === 'de' ? 'DE' : u.language === 'en' ? 'EN' : 'fr-BE',
          PhoneNumber: o.user.phone,
          TelNumber: null,
          Status: o.user.status,
          Commission: '0'
        },
        AddressID: o.user.address.addressid,
        Address: {
          Name: null,
          Company: o.user.companyname,
          Street: o.user.address.street,
          Number: o.user.address.number,
          VatNumber: o.user.tva,
          Latitude: o.user.address.lat,
          Longitude: o.user.address.lng,
          PostalCode: isNaN(parseInt(o.user.address.zip, 10)) ? null : parseInt(o.user.address.zip, 10),
          City: o.user.address.city,
          Country: o.user.address.country ? o.user.address.country : 'Belgique'
        }
      },
      Owner: {
        Email: o.owner.email,
        FirstName: o.owner.firstname,
        LastName: o.owner.lastname,
        PhoneNumber: o.owner.phone,
        NationalNumber: null
      },
      Comment: { Type: 1, Commentaire: remarque },
      AvailableDates: [],
      OrderProductsForAgency: [],
      Urgent: o.urgence,
      SentByMailAgency: false
    };

    return dbOrder;
  }
}
